import { PHONE } from '@/utils/constants';

/**
 * Fills in a partner's terms SMS template.
 *
 * {firstName} falls back to "there" rather than leaving a gap: at
 * verification the name has usually just been typed, but a journey that
 * reaches this point without one would otherwise send "Hi , thanks…".
 *
 * {phone} falls back to the shared support number, the same way ContactBox
 * resolves the one on screen — so the number quoted in the message is the
 * number the customer is looking at, and changing the partner's config
 * changes both.
 */
export function formatTermsSms(
    template: string,
    {
        firstName,
        link,
        phone,
    }: { firstName?: string; link: string; phone?: string | null }
): string {
    return template
        .replace('{firstName}', firstName?.trim() || 'there')
        .replace('{link}', link)
        .replace('{phone}', phone?.trim() || PHONE);
}
